import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';

export const deleteStandingOrderBankTransferCancelReasonOperation = async (
  cancelReasonId: number,
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const res =
      await appApi.deleteStandingOrderBankTransferCancelReason(cancelReasonId);

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    toast.success('סיבת הביטול נמחקה בהצלחה');
    setLoading(false);
    onSuccess?.();
    return true;
  } catch (e) {
    console.error(
      `deleteStandingOrderBankTransferCancelReasonOperation failed with cancelReasonId: ${cancelReasonId}, error: ${e}`,
    );
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    return false;
  }
};
